import {
  CREATE_LANDING_REQUEST,
  CREATE_LANDING_SUCCESS,
  CREATE_LANDING_FAILED,
} from './actionTypes';

const initialState = {
  loading: false,
  error: null,
};

const createInitiativeReducer = (state = initialState, {
  type, error,
}) => {
  switch (type) {
    case CREATE_LANDING_REQUEST:
      return { ...state, loading: true };
    case CREATE_LANDING_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case CREATE_LANDING_FAILED:
      return { ...state, loading: false, error };
    default:
      return state;
  }
};

export default createInitiativeReducer;
